'use client';

import { useTranslations } from 'next-intl';
import type React from 'react';

import { cn } from '@cineamo/ui/src/helpers/cn';

import { CachedContentData } from '@/hooks/useCachedContentData';
import useSharePageLink from '@/hooks/useSharePageLink';

import { IconShareBox24 } from '@cineamo/ui/src/icons/ic-share-box';

type ProgramDetailShareButtonProps = {
    content: CachedContentData;
    /** `icon` is the bare share icon, `text` the labeled link in the mobile header. */
    variant: 'icon' | 'text';
    className?: string;
};

export default function ProgramDetailShareButton(props: ProgramDetailShareButtonProps): React.JSX.Element {
    const { content, variant, className } = props;
    const t = useTranslations();
    const sharePageLink = useSharePageLink(content);

    return (
        <button
            type="button"
            onClick={sharePageLink}
            aria-label={variant === 'icon' ? t('showing-info.share') : undefined}
            className={cn(
                'flex shrink-0 items-center cursor-pointer hover:opacity-80 transition-opacity duration-150',
                variant === 'text' && 'gap-8 text-body-bold-12 text-[var(--primary-color)]',
                className
            )}>
            <IconShareBox24 className={variant === 'icon' ? 'w-20 h-20' : 'w-16 h-16'} />
            {variant === 'text' && t('showing-info.share')}
        </button>
    );
}
